<template>
  <div :class="$style.container">
    <router-link
      v-for="(option, idx) in options"
      :key="idx"
      v-slot="{ navigate, isExactActive }"
      :to="{ name: option.name }"
      custom
    >
      <div
        :class="[
          $style.link,
          { [$style.active]: isExactActive },
        ]"
        @click="navigate"
      >
        {{ $t(option.label) }}
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'TabsNavigation',
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative

  .link
    +tab-link
    cursor: pointer

    &.active
      +tab-link-active
</style>
